module.exports = __webpack_public_path__ + "static/img/ab_img2.718ffb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ab_img2.jpg
// module id = Cgyt
// module chunks = 5